export default __webpack_public_path__ + "static/media/40164.4b876205.jpg";